export const light = {
    dark: false,
    bg_l1: '#C1C1C1',
    bg_l2: '#AAAAAA',
    bg1: 'white',
    bg2: 'rgb(129 129 245)',
    bg3: 'lightgray',
    bg4: 'white',
    bg5: '#ea1d65',
    bg6: '#101010',
    bg7: '#101010',
    bg8: 'white',
    bg9: '#f1f1f1',
    bg10: 'white',
    bg11: '#92cf16',
    bg_pro_hov: '#000000a0',
    bg_mobile_container: 'white',
    bg_mobile_item: 'white',
    bg_mobile_menu: '#91d3ff',
    bg_mobile_icon: 'rgb(129 129 245)',
    bg_mobile_tech: 'white',
    bd1: 'black',
    color: 'black',
    color2: 'white',
    color3: 'gray',
    color4: 'rgb(129 129 245)',
    color5: 'rgb(253 155 40)'
};

export const dark = {
    dark: true,
    bg_l1: '#303030',
    bg_l2: '#202020',
    bg1: '#101010',
    bg2: 'rgb(85 85 165)',
    bg3: '#101010',
    bg4: '#636363',
    bg5: '#1b34b6',
    bg6: '#AAAAAA',
    bg7: 'white',
    bg8: '#eeeeee',
    bg9: '#202020',
    bg10: '#ebebeb',
    bg11: '#7dae19',
    bg_pro_hov: '#ddddddc7',
    bg_mobile_container: '#202020',
    bg_mobile_item: '#303030',
    bg_mobile_menu: '#4d80a2',
    bg_mobile_icon: '#AAAAAA',
    bg_mobile_tech: '#cfcfcf',
    bd1: '#AAAAAA',
    color: 'white',
    color2: 'black',
    color3: 'lightgray',
    color4: 'rgb(166 166 255)',
    color5: 'rgb(255 179 92)',
};